import config from "@/config";
import Axios from "@/utils/Axios";
import { RequestModelParams } from "./types";

export const fetchModelList = () => Axios.get("/model_list", {}, {}, config.aiCreator);

export const requestModel = async (data: RequestModelParams) => {
  return Axios.post("/mk/push", data, {}, config.aiCreator);
};
